<template>
    <div class="subscription-review-card">
        <rt-picture class="quote-icon" src="/assets/app/class/icon-dobule-quote.svg" />
        <div class="feedback-wrapper">
            <h3 class="feddback-content">{{ reviewer.feedback }}</h3>
            <div class="user-info-wrapper flex-wrapper">
                <img class="user-avatar" :src="reviewer.icon">
                <div class="name-info-wrapper">
                    <div class="user-name-wrapper flex-wrapper">
                        <h4 class="user-name">{{ reviewer.name }}</h4>
                        <!-- <rt-picture class="social-icons" src="/assets/app/class/social-icons.svg" /> -->
                    </div>
                    <p class="user-role">{{ reviewer.role }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RtPicture from '../../common/Picture.vue';

export default {
  props: ['reviewer'],
  components: {
    RtPicture
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-review-card {
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  padding: 49px 40px 57px;
  border-radius: 50px 50px 50px 0;
  box-shadow: 0px 4px 8px rgba(191, 197, 208, 0.22);
  .quote-icon {
    margin-right: 32px;
  }
  .feedback-wrapper {
    .feddback-content {
      margin-top: -10px;
      text-align: left;
      font-weight: 700;
      font-size: 22px;
      color: $title-dark-grey;
      line-height: 1.5;
    }
    .user-info-wrapper {
      padding-top: 26px;
      .user-avatar {
        margin-right: 16px;
      }
      .user-name {
        // margin-right: 13px;
        font-weight: 700;
        font-size: 16px;
        color: $title-dark-grey;
        line-height: 1;
      }
      .user-role {
        padding-top: 10px;
        font-size: 14px;
        color: $title-grey;
        line-height: 1;
      }
    }
  }
  @media (max-width: 767px) {
    border-radius: 30px 30px 30px 0;
    padding: 40px 30px;
    .quote-icon {
      width: 14px;
      margin-right: 16px;
    }
    .feedback-wrapper {
      .feddback-content {
        font-size: 14px;
      }
      .user-info-wrapper {
        .user-avatar {
          width: 32px;
          margin-right: 10px;
        }
        .user-name, .user-role {
          font-size: 10px;
          margin: 0;
        }
        .social-icons {
          display: none;
        }
      }
    }
  }
}
</style>